import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { HubLoginComponent } from './hub-login.component';
import { SelectAccountModule } from '../select-account/select-account.module';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { TrInfoTooltipModule } from '../tr-info-tooltip/tr-info-tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SvgIconModule,
        TrSpinnerButtonDirectiveModule,
        SelectAccountModule,
        TrInfoTooltipModule,
    ],
    exports: [HubLoginComponent],
    declarations: [HubLoginComponent],
    entryComponents: [HubLoginComponent],
    providers: [FeatureFlagService],
})
export class HubLoginModule { }
